import React, {useState} from "react";
import {Tooltip} from "antd";
import {
    ThunderboltFilled,
    InsertRowAboveOutlined,
    ScheduleOutlined,
    ClockCircleOutlined,
    CalendarOutlined
} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {
    TableContainer,
    ActionButtons,
    ProgressWrapper,
    ClickableSpan,
    GroupHeaderTitle
} from "./ResponsiveDataTable.styles";
import {useHistory} from "react-router-dom";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {isNumeric, truncateString} from "../../../../utils/helpers";
import {PoolCouriersDrawer} from "../poolCouriersDrawer/PoolCouriersDrawer";
import {EmptyMessage} from "../../../_defaultComponents/EmptyMessage/EmptyMessage";
import {useStore} from "hooks/useStore";

const TABLE_PREFIX = "poolTable";

export const courierTypeMapping = {
    inSlot: {label: "Slot Seçen Kuryeler", value: "inSlot"},
    unAvailable: {label: "Meşgul Kuryeler", value: "unAvailable"},
    onBreak: {label: "Moladaki Kuryeler", value: "onBreak"},
    active: {label: "Aktif Kuryeler", value: "active"},
    onDelivery: {label: "Siparişteki Kuryeler", value: "onDelivery"},
    available: {label: "Müsait Kuryeler", value: "available"}
};

const ANLIK_TITLE = (
    <GroupHeaderTitle>
        <ClockCircleOutlined />
        Anlık
    </GroupHeaderTitle>
);

const GUNLUK_TITLE = (
    <GroupHeaderTitle>
        <CalendarOutlined />
        Günlük
    </GroupHeaderTitle>
);

const ResponsiveDataTable = ({data = [], loading, currentPage, setCurrentPage, dataCount}) => {
    const {t} = useTranslation(["pools"]);
    const history = useHistory();
    const stores = useStore();
    const [selectedPoolId, setSelectedPoolId] = useState(undefined);
    const [selectedType, setSelectedType] = useState(undefined);
    const [selectedPoolName, setSelectedPoolName] = useState(undefined);
    const translateColorByProgress = progress => {
        //smooth transition between colors
        const endColor = [255, 0, 0];
        const startColor = [140, 158, 51];
        const r = Math.floor(startColor[0] + (endColor[0] - startColor[0]) * progress * 0.01);
        const g = Math.floor(startColor[1] + (endColor[1] - startColor[1]) * progress * 0.01);
        const b = Math.floor(startColor[2] + (endColor[2] - startColor[2]) * progress * 0.01);
        return `rgb(${r},${g},${b})
    `;
    };

    const renderActionButtons = id => {
        const permisions = {
            showForecastTable: !stores.meStore.checkRole("isSOperationUser"),
            showSlotTable: true,
            showShifts: true
        };
        return (
            <ActionButtons>
                {/* {permisions.showForecastTable && (
                    <Tooltip title={"Forecast"}>
                        <CustomButton
                            data-testid="poolShiftStatDetailButton"
                            onClick={() => history.push(`/pools/${id}/daily-forecasts`)}
                            icon={<ThunderboltFilled />}
                        ></CustomButton>
                    </Tooltip>
                )}
                {permisions.showSlotTable && (
                    <Tooltip title={"Slot"}>
                        <CustomButton
                            data-testid="poolShiftStatDetailButton"
                            onClick={() => history.push(`/pools/${id}/daily-slots`)}
                            icon={<InsertRowAboveOutlined />}
                        ></CustomButton>
                    </Tooltip>
                )} */}
                {permisions.showShifts && (
                    <Tooltip title={"Vardiyalar"}>
                        <CustomButton
                            data-testid="poolShiftStatDetailButton"
                            onClick={() => history.push(`/pools/courier-shifts?poolId=${id}`)}
                            icon={<ScheduleOutlined />}
                        ></CustomButton>
                    </Tooltip>
                )}
            </ActionButtons>
        );
    };

    const onSelectType = ({poolId, type, poolName = ""}) => {
        setSelectedPoolId(poolId);
        setSelectedType(type);
        setSelectedPoolName(poolName);
    };
    const onDrawerClose = () => {
        setSelectedPoolId(undefined);
        setSelectedType(undefined);
        setSelectedPoolName(undefined);
    };

    return (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                pagination={
                    false /* {
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false
                } */
                }
                rowKey="_id"
                rowClassName="hello"
                dataSource={data}
                data-testid="poolDataTable"
                size="small"
                scroll={{x: "max-content", y: "calc(100vh - 220px)"}}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                loading={loading}
            >
                <TableContainer.Column
                    className="pool-available-rates-column"
                    dataIndex="name"
                    title={t("fields.poolRegion", {ns: "pools"})}
                    fixed="left"
                    width={150}
                    render={name => (
                        <span
                            data-testid="poolName"
                            data-label={`${t("fields.poolRegion", {ns: "pools"})}:`}
                        >
                            <Tooltip title={name}>{truncateString(`${name}`, 30)}</Tooltip>
                        </span>
                    )}
                    sorter={(a, b) => a.name.localeCompare(b.name, "tr")}
                />

                <TableContainer.ColumnGroup title={ANLIK_TITLE} className="anlik-group-header">
                    <TableContainer.Column
                        width={95}
                        className="pool-available-rates-column anlik-col"
                        dataIndex="availableRate"
                        title={
                            <>
                                Anlık Havuz <br />
                                Yoğunluğu(%)
                            </>
                        }
                        align="center"
                        defaultSortOrder="descend"
                        sorter={(a, b) => {
                            const aIsNumeric = isNumeric(a.availableRate);
                            const bIsNumeric = isNumeric(b.availableRate);
                            if (!aIsNumeric && !bIsNumeric) {
                                return a.queuedDeliveryCount - b.queuedDeliveryCount;
                            }
                            if (!aIsNumeric) return 1;
                            if (!bIsNumeric) return -1;
                            return Number(a.availableRate) - Number(b.availableRate);
                        }}
                        render={(availableRate = 0) => {
                            if (!isNumeric(availableRate)) {
                                return (
                                    <span
                                        data-testid="poolAvailableRate"
                                        data-label={"Yoğunluk Oranı(%):"}
                                    >
                                        <Tooltip title={availableRate}>
                                            <b>{availableRate}</b>
                                        </Tooltip>
                                    </span>
                                );
                            }
                            return (
                                <span
                                    data-testid="poolAvailableRate"
                                    data-label={"Yoğunluk Oranı(%):"}
                                >
                                    <Tooltip title={`Yoğunluk Oranı : ${availableRate}%`}>
                                        <b style={{color: translateColorByProgress(availableRate)}}>
                                            {availableRate}%
                                        </b>
                                    </Tooltip>
                                </span>
                            );
                        }}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column anlik-col"
                        align="center"
                        dataIndex="inSlotCouriersCount"
                        title={
                            <>
                                Vardiyası Olan
                                <br />
                                Kurye Sayısı
                            </>
                        }
                        sorter={(a, b) => a.inSlotCouriersCount - b.inSlotCouriersCount}
                        render={(inSlotCouriersCount = 0, stats) => (
                            <ClickableSpan
                                data-testid="poolInSlotCouriersCount"
                                data-label={"Vardiyası Olan Kurye Sayısı:"}
                                onClick={() =>
                                    onSelectType({
                                        poolId: stats._id,
                                        type: courierTypeMapping.inSlot.value,
                                        poolName: stats?.name
                                    })
                                }
                            >
                                <Tooltip title={"Vardiyası Olan Kurye Sayısı"}>
                                    {inSlotCouriersCount}
                                </Tooltip>
                            </ClickableSpan>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column anlik-col"
                        align="center"
                        dataIndex="unAvailableCouriersCount"
                        title={
                            <>
                                Meşgul Kurye
                                <br />
                                Sayısı
                            </>
                        }
                        sorter={(a, b) => a.unAvailableCouriersCount - b.unAvailableCouriersCount}
                        render={(unAvailableCouriersCount = 0, stats) => (
                            <ClickableSpan
                                data-testid="poolUnAvailableCouriersCount"
                                data-label={"Meşgul Kurye Sayısı:"}
                                onClick={() =>
                                    onSelectType({
                                        poolId: stats._id,
                                        type: courierTypeMapping.unAvailable.value,
                                        poolName: stats?.name
                                    })
                                }
                            >
                                <Tooltip title={"Meşgul Kurye Sayısı"}>
                                    {unAvailableCouriersCount}
                                </Tooltip>
                            </ClickableSpan>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column anlik-col"
                        align="center"
                        dataIndex="onBreakCouriersCount"
                        title={
                            <>
                                Moladaki Kurye
                                <br />
                                Sayısı
                            </>
                        }
                        sorter={(a, b) => a.onBreakCouriersCount - b.onBreakCouriersCount}
                        render={(onBreakCouriersCount = 0, stats) => (
                            <ClickableSpan
                                data-testid="poolOnBreakCouriersCount"
                                data-label={"Moladaki Kurye Sayısı:"}
                                onClick={() =>
                                    onSelectType({
                                        poolId: stats._id,
                                        type: courierTypeMapping.onBreak.value,
                                        poolName: stats?.name
                                    })
                                }
                            >
                                <Tooltip title={"Moladaki Kurye Sayısı"}>
                                    {onBreakCouriersCount}
                                </Tooltip>
                            </ClickableSpan>
                        )}
                    />
                    <TableContainer.Column
                        width={75}
                        className="pool-available-rates-column anlik-col"
                        align="center"
                        dataIndex="activeCouriersCount"
                        title={
                            <>
                                Aktif Kurye
                                <br /> Sayısı
                            </>
                        }
                        sorter={(a, b) => a.activeCouriersCount - b.activeCouriersCount}
                        render={(activeCouriersCount = 0, stats) => (
                            <ClickableSpan
                                data-testid="poolActiveCouriersCount"
                                data-label={"Aktif Kurye Sayısı:"}
                                onClick={() =>
                                    onSelectType({
                                        poolId: stats._id,
                                        type: courierTypeMapping.active.value,
                                        poolName: stats?.name
                                    })
                                }
                            >
                                <Tooltip title={"Aktif Kurye Sayısı"}>
                                    {activeCouriersCount}
                                </Tooltip>
                            </ClickableSpan>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column anlik-col"
                        align="center"
                        dataIndex="onDeliveryCouriersCount"
                        title={
                            <>
                                Siparişteki
                                <br />
                                Kurye Sayısı
                            </>
                        }
                        sorter={(a, b) => a.onDeliveryCouriersCount - b.onDeliveryCouriersCount}
                        render={(onDeliveryCouriersCount = 0, stats) => (
                            <ClickableSpan
                                data-testid="poolOnDeliveryCouriersCount"
                                data-label={"Siparişteki Kurye Sayısı:"}
                                onClick={() =>
                                    onSelectType({
                                        poolId: stats._id,
                                        type: courierTypeMapping.onDelivery.value,
                                        poolName: stats?.name
                                    })
                                }
                            >
                                <Tooltip title={"Siparişteki Kurye Sayısı"}>
                                    {onDeliveryCouriersCount}
                                </Tooltip>
                            </ClickableSpan>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column anlik-col"
                        align="center"
                        dataIndex="availableCouriersCount"
                        title={
                            <>
                                Müsait Kurye
                                <br />
                                Sayısı
                            </>
                        }
                        sorter={(a, b) => a.availableCouriersCount - b.availableCouriersCount}
                        render={(availableCouriersCount = 0, stats) => (
                            <ClickableSpan
                                data-testid="poolAvailableCouriersCount"
                                data-label={"Müsait Kurye Sayısı:"}
                                onClick={() =>
                                    onSelectType({
                                        poolId: stats._id,
                                        type: courierTypeMapping.available.value,
                                        poolName: stats?.name
                                    })
                                }
                            >
                                <Tooltip title={"Müsait Kurye Sayısı"}>
                                    {availableCouriersCount}
                                </Tooltip>
                            </ClickableSpan>
                        )}
                    />
                    <TableContainer.Column
                        width={150}
                        className="pool-available-rates-column anlik-col"
                        align="center"
                        dataIndex="activeOrderCount"
                        title={
                            <>
                                Aktif Sipariş
                                <br />
                                Sayısı
                            </>
                        }
                        sorter={(a, b) => a.activeOrderCount - b.activeOrderCount}
                        render={(activeOrderCount = 0, stats) => (
                            <span
                                data-testid="poolCouriersCount"
                                data-label={"Aktif Sipariş Sayısı:"}
                            >
                                <Tooltip title={"Aktif Sipariş Sayısı"}>{activeOrderCount}</Tooltip>
                            </span>
                        )}
                    />
                    <TableContainer.Column
                        width={150}
                        className="pool-available-rates-column anlik-col"
                        align="center"
                        dataIndex="queuedDeliveryCount"
                        title={
                            <>
                                Kuyrukta Bekleyen
                                <br />
                                Sipariş Sayısı
                            </>
                        }
                        sorter={(a, b) => a.queuedDeliveryCount - b.queuedDeliveryCount}
                        render={(queuedDeliveryCount = 0, stats) => (
                            <span
                                data-testid="poolCouriersCount"
                                data-label={"Kuyrukta Bekleyen Sipariş Sayısı:"}
                            >
                                <Tooltip title={"Kuyrukta Bekleyen Sipariş Sayısı"}>
                                    {queuedDeliveryCount}
                                </Tooltip>
                            </span>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column anlik-col"
                        align="center"
                        dataIndex="onTheWayOrderCount"
                        title={
                            <>
                                Yoldaki Sipariş
                                <br />
                                Sayısı
                            </>
                        }
                        sorter={(a, b) => a.onTheWayOrderCount - b.onTheWayOrderCount}
                        render={(onTheWayOrderCount = 0, stats) => (
                            <span
                                data-testid="onTheWayOrderCount"
                                data-label={"Yoldaki Sipariş Sayısı:"}
                            >
                                <Tooltip title={"Yoldaki Sipariş Sayısı"}>
                                    {onTheWayOrderCount}
                                </Tooltip>
                            </span>
                        )}
                    />
                </TableContainer.ColumnGroup>

                <TableContainer.ColumnGroup title={GUNLUK_TITLE} className="gunluk-group-header">
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column gunluk-col"
                        align="center"
                        dataIndex="deliveredOrderCount"
                        title={
                            <>
                                Teslim Edilen
                                <br /> Sipariş Sayısı
                            </>
                        }
                        sorter={(a, b) => a.deliveredOrderCount - b.deliveredOrderCount}
                        render={(deliveredOrderCount = 0, stats) => (
                            <span
                                data-testid="deliveredOrderCount"
                                data-label={"Teslim Edilen Sipariş Sayısı:"}
                            >
                                <Tooltip title={"Teslim Edilen Sipariş Sayısı"}>
                                    {deliveredOrderCount}
                                </Tooltip>
                            </span>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column gunluk-col"
                        align="center"
                        dataIndex="orderCountOver40Minutes"
                        title={
                            <>
                                40 dk Üzeri
                                <br /> Sipariş Sayısı
                            </>
                        }
                        sorter={(a, b) => a.orderCountOver40Minutes - b.orderCountOver40Minutes}
                        render={(orderCountOver40Minutes = 0, stats) => (
                            <span
                                data-testid="over40MinutesDeliveryCount"
                                data-label={"40 dk Üzeri Sipariş Sayısı"}
                            >
                                <Tooltip title={"40 dk Üzeri Sipariş Sayısı"}>
                                    {orderCountOver40Minutes}
                                </Tooltip>
                            </span>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column gunluk-col"
                        align="center"
                        dataIndex="canceledOrderCount"
                        title={
                            <>
                                İptal Edilen
                                <br /> Sipariş Sayısı
                            </>
                        }
                        sorter={(a, b) => a.canceledOrderCount - b.canceledOrderCount}
                        render={(canceledOrderCount = 0, stats) => (
                            <span
                                data-testid="canceledOrderCount"
                                data-label={"İptal Edilen Sipariş Sayısı"}
                            >
                                <Tooltip title={"İptal Edilen Sipariş Sayısı"}>
                                    {canceledOrderCount}
                                </Tooltip>
                            </span>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column gunluk-col"
                        align="center"
                        dataIndex="averageWaitingQueueDuration"
                        title={
                            <>
                                Ortalama
                                <br /> Kuyruk Süresi
                            </>
                        }
                        sorter={(a, b) =>
                            a.averageWaitingQueueDuration - b.averageWaitingQueueDuration
                        }
                        render={(averageWaitingQueueDuration = 0, stats) => (
                            <span
                                data-testid="averageWaitingQueueDuration"
                                data-label={"Ortalama Kuyruk Süresi"}
                            >
                                <Tooltip title={"Ortalama Kuyruk Süresi"}>
                                    {averageWaitingQueueDuration}
                                </Tooltip>
                            </span>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column gunluk-col"
                        align="center"
                        dataIndex="averagePickupDuration"
                        title={
                            <>
                                Ortalama Teslim
                                <br /> Alma Süresi
                            </>
                        }
                        sorter={(a, b) => a.averagePickupDuration - b.averagePickupDuration}
                        render={(averagePickupDuration = 0, stats) => (
                            <span
                                data-testid="averagePickupDuration"
                                data-label={"Ortalama Teslim Alma Süresi"}
                            >
                                <Tooltip title={"Ortalama Teslim Alma Süresi"}>
                                    {averagePickupDuration}
                                </Tooltip>
                            </span>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column gunluk-col"
                        align="center"
                        dataIndex="averageOnDeliveryDuration"
                        title={
                            <>
                                Ortalama
                                <br /> Taşıma Süresi
                            </>
                        }
                        sorter={(a, b) => a.averageOnDeliveryDuration - b.averageOnDeliveryDuration}
                        render={(averageOnDeliveryDuration = 0, stats) => (
                            <span
                                data-testid="averageOnDeliveryDuration"
                                data-label={"Ortalama Taşıma Süresi"}
                            >
                                <Tooltip title={"Ortalama Taşıma Süresi"}>
                                    {averageOnDeliveryDuration}
                                </Tooltip>
                            </span>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column gunluk-col"
                        align="center"
                        dataIndex="averageOrderDuration"
                        title={
                            <>
                                Ortalama
                                <br /> Sipariş Süresi
                            </>
                        }
                        sorter={(a, b) => a.averageOrderDuration - b.averageOrderDuration}
                        render={(averageOrderDuration = 0, stats) => (
                            <span
                                data-testid="averageOrderDuration"
                                data-label={"Ortalama Sipariş Süresi"}
                            >
                                <Tooltip title={"Ortalama Sipariş Süresi"}>
                                    {averageOrderDuration}
                                </Tooltip>
                            </span>
                        )}
                    />
                    <TableContainer.Column
                        width={100}
                        className="pool-available-rates-column gunluk-col"
                        align="center"
                        dataIndex="averageOrderKms"
                        title={
                            <>
                                Ortalama
                                <br /> KM
                            </>
                        }
                        sorter={(a, b) => a.averageOrderKms - b.averageOrderKms}
                        render={(averageOrderKms = 0, stats) => (
                            <span data-testid="averageOrderKms" data-label={"Ortalama KM"}>
                                <Tooltip title={"Ortalama KM"}>{averageOrderKms} km</Tooltip>
                            </span>
                        )}
                    />
                </TableContainer.ColumnGroup>

                <TableContainer.Column
                    className="pool-available-rates-column"
                    dataIndex="integrationType"
                    title={t("filters.integrationType", {ns: "common"})}
                    width={150}
                    render={integrationType => (
                        <span
                            data-testid="integrationType"
                            data-label={t("filters.integrationType", {ns: "common"})}
                        >
                            <Tooltip title={integrationType}>
                                {integrationType === "dedicated"
                                    ? "Dedike"
                                    : integrationType === "pool"
                                    ? "Havuz"
                                    : integrationType === "dedicatedIntegration"
                                    ? "Dedike Entegrasyon"
                                    : "-"}
                            </Tooltip>
                        </span>
                    )}
                />
                <TableContainer.Column
                    className="pool-available-rates-column"
                    align="center"
                    width={140}
                    title={t("actions.action", {ns: "common"})}
                    dataIndex="_id"
                    render={renderActionButtons}
                />
            </TableContainer>
            <PoolCouriersDrawer
                onClose={onDrawerClose}
                poolId={selectedPoolId}
                type={selectedType}
                poolName={selectedPoolName}
                visible={selectedPoolId !== undefined && selectedType !== undefined}
            />
        </>
    );
};

export default ResponsiveDataTable;
